import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFilterSpell({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.33 11.645a1.5 1.5 0 0 1 1.341 0l.553.276a.5.5 0 0 1-.353.93l-.095-.036-.552-.276a.5.5 0 0 0-.448 0l-1.105.553c-.422.21-.92.21-1.342 0l-1.105-.553a.5.5 0 0 0-.448 0l-1.105.553c-.422.21-.92.21-1.342 0l-1.105-.553a.5.5 0 0 0-.448 0l-1.105.553c-.422.21-.92.21-1.342 0l-1.105-.553a.5.5 0 0 0-.448 0l-.552.276a.5.5 0 0 1-.448-.894l.553-.276a1.5 1.5 0 0 1 1.342 0l1.105.552c.141.07.307.07.448 0l1.105-.552a1.5 1.5 0 0 1 1.342 0l1.105.552c.141.07.307.07.448 0l1.105-.552c.422-.212.92-.211 1.342 0l1.105.552c.141.07.307.07.448 0l1.105-.552z" fill={fill}/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.59 4.754c1.318 0 2.16.697 2.16 1.787v3.28c0 .351-.222.564-.537.564-.31 0-.522-.202-.532-.532v-.46h-.026c-.315.604-1.007.986-1.714.986-1.064 0-1.814-.66-1.814-1.637 0-.95.734-1.534 2.02-1.606l1.493-.088v-.42c0-.603-.408-.965-1.09-.965-.537 0-.893.192-1.203.688a.51.51 0 0 1-.455.237c-.28 0-.48-.186-.48-.465 0-.114.03-.237.098-.361.284-.615 1.105-1.008 2.08-1.008zm-.293 3.151c-.666.047-1.044.341-1.044.806 0 .475.398.785.992.785.78 0 1.395-.537 1.395-1.245v-.429l-1.343.083zM4.901 2.75c.403 0 .651.186.806.6L7.98 9.5a.984.984 0 0 1 .072.34c0 .306-.243.528-.578.528-.31 0-.481-.145-.584-.475L6.32 8.287h-2.85L2.907 9.89c-.108.335-.278.48-.578.48-.346 0-.579-.212-.579-.527 0-.088.02-.202.072-.341L4.09 3.354c.15-.413.403-.604.811-.604zM3.765 7.342h2.262l-1.12-3.27h-.032l-1.11 3.27z" fill={fill}/>
        </svg>

    );
}

export default IconFilterSpell;
